import React from 'react';
import SeasonCreationWizard from '../components/SeasonCreationWizard';

const SeasonCreate: React.FC = () => {
  return <SeasonCreationWizard />;
};

export default SeasonCreate;


